import { Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";



export const formatDateTimeToIST = (date) => {
    if (!date) return null;
  

    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, 
    };
  
    const formatter = new Intl.DateTimeFormat("en-GB", options);
    const parts = formatter.formatToParts(new Date(date));
  

    const day = parts.find((p) => p.type === "day").value;
    const month = parts.find((p) => p.type === "month").value;
    const year = parts.find((p) => p.type === "year").value;
    const hour = parts.find((p) => p.type === "hour").value;
    const minute = parts.find((p) => p.type === "minute").value;
    const second = parts.find((p) => p.type === "second").value;
  
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  };
  



  export const useOrganizationId = () => {
    const organizationId = useSelector((state) => state?.authUser?.data?._id);
    return organizationId;
  };



  export const confirmPause = (id) => {
    
    const MySwal = withReactContent(Swal);
  
    MySwal.fire({
      title: "Tracking Stopped",
      text: "You have stopped the tracking",
      icon: "success",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });
  };

  export const confirmProcess = (navigate) => {
    const MySwal = withReactContent(Swal);
  
    MySwal.fire({
      title: "Video Created",
      text: "Your video has been successfully created.",
      icon: "success",
      // showCancelButton: true, // Show Cancel button
      // confirmButtonText: "Go to Video", // Custom text
      // cancelButtonText: "Close", // Close button
      confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
  
    });
  };

  export const confirmPending = () => {
    const MySwal = withReactContent(Swal);
  
    MySwal.fire({
      title: "Processing",
      text: "You will get notified when the process has been completd...",
      icon: "success",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
    });
  };



 export const renderSkeletonTable = (columns) => (
    <Table>
      <TableHead>
        <TableRow>
          {columns.map((col, index) => (
            <TableCell key={index}>
              <Skeleton variant="text" width="80%" height={30} />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(10)].map((_, rowIndex) => (
          <TableRow key={rowIndex}>
            {columns.map((_, colIndex) => (
              <TableCell key={colIndex}>
                <Skeleton variant="rectangular" width="100%" height={40} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );




  export const SkeletonCard = () => (
  <div className="d-flex align-items-start gap-3 py-3 border-bottom">
    <div
      className="rounded-circle"
      style={{
        width: "50px",
        height: "50px",
        backgroundColor: "#e0e0e0",
      }}
    />
    <div className="flex-grow-1">
      <div
        style={{
          height: "14px",
          width: "80%",
          backgroundColor: "#e0e0e0",
          marginBottom: "6px",
          borderRadius: "4px",
        }}
      />
      <div
        style={{
          height: "12px",
          width: "60%",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
        }}
      />
    </div>
    <div style={{ textAlign: "right" }}>
      <div
        style={{
          height: "14px",
          width: "60px",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
          marginBottom: "6px",
        }}
      />
      <div
        style={{
          height: "14px",
          width: "60px",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
        }}
      />
    </div>
  </div>
);